import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import { Box, Button } from '@mui/material';

import useStores from 'hooks/use-stores';

import useStyles from './styles';

const LoginButton = ({ onLogin }) => {
    const { classes } = useStyles();
    const { dialogStore } = useStores();

    const handleClick = useCallback(() => {
        dialogStore.openLoginDialog();
        onLogin && onLogin();
    }, [dialogStore, onLogin]);

    return (
        <Box className={classes.container}>
            <Box>{'Please Login to generate API key'}</Box>

            <Button color="primary" variant="contained" onClick={handleClick} className={classes.button}>
                {'Login'}
            </Button>
        </Box>
    );
};

LoginButton.propTypes = {
    onLogin: PropTypes.func
};

export default observer(LoginButton);
